module.exports = __webpack_public_path__ + "img/v3.5.ef6ec6a9.png";